export default "__VITE_ASSET__CynlKvdV__"